import { WifiInfo, WifiSupportOption, WifiSupportType } from '@/types/residents/wifi';
import { strings } from '@/constants/residents/strings';

export const buildSupportOptions = (wifiInfo?: WifiInfo): WifiSupportOption[] => {
  if (!wifiInfo) return [];
  const options: WifiSupportOption[] = [];
  if (wifiInfo.supportPhoneNumber) {
    options.push({
      type: WifiSupportType.TEXT,
      title: strings.wifi.support.text,
      value: wifiInfo.supportPhoneNumber,
      icon: 'chatbubble-outline',
      urlPrefix: 'sms:',
    });
  }
  if (wifiInfo.supportEmail) {
    options.push({
      type: WifiSupportType.EMAIL,
      title: strings.wifi.support.email,
      value: wifiInfo.supportEmail,
      icon: 'mail-outline',
      urlPrefix: 'mailto:',
    });
  }
  if (wifiInfo.supportWebsite) {
    options.push({
      type: WifiSupportType.WEBSITE,
      title: strings.home.wifi.support.website,
      value: wifiInfo.supportWebsite,
      icon: 'globe-outline',
      urlPrefix: '',
    });
  }
  return options;
};


